import { useState } from 'react';
import { Link } from 'react-router-dom';

function Header({ openModal }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const handleRequestService = () => {
    closeMenu();
    openModal();
  };

  return (
    <header className={`header ${menuOpen ? 'menu-open' : ''}`}>
      <div className="container header-inner">
        <div className="nav-brand">
          <Link to="/" className="logo" onClick={closeMenu}>
            <img src="/proofsec.png" width="168" height="48" alt="ProofSec Logo" className="logo-image" />
          </Link>
        </div>
        <button
          type="button"
          className="burger"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className="burger-line" />
          <span className="burger-line" />
          <span className="burger-line" />
        </button>
        <nav className="nav-menu">
          <a href="/#home" className="nav-link" onClick={closeMenu}>Home</a>
          <a href="/#services" className="nav-link" onClick={closeMenu}>Audit Services</a>
          <a href="/#development" className="nav-link" onClick={closeMenu}>Development</a>
          <a href="/#process" className="nav-link" onClick={closeMenu}>Process</a>
          <a href="/#sample" className="nav-link" onClick={closeMenu}>Sample Report</a>
          <button type="button" className="cta-button nav-cta" onClick={handleRequestService}>Request Service</button>
        </nav>
      </div>
    </header>
  );
}

export default Header;
